module.exports = __webpack_public_path__ + "static/logo-long-text-ba2d2ecb886dc18c35249a1571a1989f.svg";